import FileField from "./File";
import TextField from "./Text";
import BooleanField from "./Boolean";
import NumberField from "./Number";
import Checkboxes from "./Checkboxes";
import Radio from "./Radio";
import DateField from "./Date";
import PeriodField from "./Period";
import ListSingle from "./ListSingle";
import ListMultiple from "./ListMultiple";

import Photo from "./Photo";
import Comment from "./Comment";
import Gender from "./Gender";
import Phone from "./Phone";
import Email from "./Email";
import Skills from "./Skills/index";
import Education from "./Education/index";
import Career from "./Career";
import Portfolio from "./Portfolio";
import AdditionalPhone from "./AdditionalPhone";
import Socials from "./Socials";
import ResidentialAddress from "./ResidentialAddress";
import RegistrationAddress from "./RegistrationAddress";
import PersonalData from "./PersonalData/index";
import Auto from "./Auto";

import FriendsInCompany from "./FriendsInCompany";
import RecentJobs from "./RecentJobs/index";
import Experience from "./Experience";
import Passport from "./Passport";
import Documents from "./Documents";

import * as customTypes from "@/domains/profile/constants/custom-types";
import * as systemTypes from "@/domains/profile/constants/system-types";

export const customFieldComponents = {
    [customTypes.FIELD_TYPE_FILE]: FileField,
    [customTypes.FIELD_TYPE_TEXT]: TextField,
    [customTypes.FIELD_TYPE_NUMBER]: NumberField,
    [customTypes.FIELD_TYPE_BOOLEAN]: BooleanField,
    [customTypes.FIELD_TYPE_CHECKBOXES]: Checkboxes,
    [customTypes.FIELD_TYPE_RADIO]: Radio,
    [customTypes.FIELD_TYPE_DATE]: DateField,
    [customTypes.FIELD_TYPE_PERIOD]: PeriodField,
    [customTypes.FIELD_TYPE_LIST_SINGLE]: ListSingle,
    [customTypes.FIELD_TYPE_LIST_MULTIPLE]: ListMultiple,
};

export const systemFieldComponents = {
    [systemTypes.FIELD_TYPE_FULL_NAME]: TextField,
    [systemTypes.FIELD_TYPE_PHOTO]: Photo,
    [systemTypes.FIELD_TYPE_BIRTHDAY]: DateField,
    [systemTypes.FIELD_TYPE_GENDER]: Gender,
    [systemTypes.FIELD_TYPE_PHONE]: Phone,
    [systemTypes.FIELD_TYPE_EMAIL]: Email,
    [systemTypes.FIELD_TYPE_CITIZENSHIP]: ListSingle,
    [systemTypes.FIELD_TYPE_SKILLS]: Skills,
    [systemTypes.FIELD_TYPE_EDUCATION]: Education,
    [systemTypes.FIELD_TYPE_CAREER]: Career,
    [systemTypes.FIELD_TYPE_PORTFOLIO]: Portfolio,
    [systemTypes.FIELD_TYPE_ADDITIONAL_PHONE]: AdditionalPhone,
    [systemTypes.FIELD_TYPE_WAY_TO_WORK]: ListSingle,
    [systemTypes.FIELD_TYPE_COVID]: BooleanField,
    [systemTypes.FIELD_TYPE_TRAVELING_WORK]: BooleanField,
    [systemTypes.FIELD_TYPE_ADDITIONAL_EDUCATION]: TextField,
    [systemTypes.FIELD_TYPE_SOCIALS]: Socials,
    [systemTypes.FIELD_TYPE_COMMENT]: Comment,
    [systemTypes.FIELD_TYPE_RESIDENTIAL_ADDRESS]: ResidentialAddress,
    [systemTypes.FIELD_TYPE_METRO]: ListSingle,
    [systemTypes.FIELD_TYPE_REGISTRATION_ADDRESS]: RegistrationAddress,
    [systemTypes.FIELD_TYPE_PERSONAL_DATA]: PersonalData,
    [systemTypes.FIELD_TYPE_AUTO]: Auto,
    [systemTypes.FIELD_TYPE_DESIRED_POSITION]: ListSingle,
    [systemTypes.FIELD_TYPE_VACANCY_SOURCE]: ListSingle,
    [systemTypes.FIELD_TYPE_FRIENDS_IN_COMPANY]: FriendsInCompany,
    [systemTypes.FIELD_TYPE_RECENT_JOBS]: RecentJobs,
    [systemTypes.FIELD_TYPE_EXPERIENCE]: Experience,
    [systemTypes.FIELD_TYPE_PASSPORT]: Passport,
    [systemTypes.FIELD_TYPE_DOCUMENTS]: Documents,
};
